import { getParticipantById } from '../../../../react/features/base/participants/functions';
import KeyboardFocusable from '../KeyboardFocusable';

import Controls from './Controls';

import WildixUIEvents from '../../../service/WildixUIEvents';


export default class ParticipantItems extends Controls {
    namespace = 'participantItems';
    constructor() {
        super();
        this._items = [];
        this._visibleArray = [];
        this._focusedElement = null;
        this.currentId = null;
        this.updateContainer();

        this.itemHeight = 170;
        this.isFocused = false;

        APP.wildix.eventEmitter.on(WildixUIEvents.REMOTE_VIDEO_DESTROYED, this._handleUserLeft.bind(this));
        APP.wildix.eventEmitter.on(WildixUIEvents.REMOTE_VIDEO_CREATED, this._handleUserJoined.bind(this));

        APP.wildix.eventEmitter.on(WildixUIEvents.REMOTE_PARTICIPANT, remoteArray => {
            this._items = remoteArray;
        });

        APP.wildix.eventEmitter.on(WildixUIEvents.VISIBLE_PARTICIPANT_LIST, arrListIds => {
            this._visibleArray = Array.from(arrListIds);
            if (this.isFocused && this._focusedElement) {
                this.selectElement();
            }
        });
    }

    _handleUserJoined() {
        if (this._focusedElement) {
            this._container.scrollTo(0, this._focusedElement?.el.offsetTop);
        }
    }

    _handleUserLeft(userId) {
        const idx = this._items.findIndex(item => item.includes(userId));

        if (userId !== this.currentId) {
            return;
        }
        this.unfocus();
        this._items.splice(idx, 1);

        if (this._items[idx]) {
            this._currentIndex = idx;
        } else if (this._items[idx - 1]) {
            this._currentIndex = idx - 1;
        }
        this.selectElement();
    }

    updateContainer() {
        this._container = document.querySelector('.remote-videos');
    }

    selectElement() {
        this.currentId = this._items[this._currentIndex];

        let element = document.getElementById(`participant_${this.currentId}`);

        if (!element) {
            const participant = getParticipantById(APP.store.getState(), this.currentId);

            if (!participant?.fakeParticipant && participant.name !== 'video') {
                return;
            }
            element = document.getElementById('sharedVideoContainer');
        }

        if (this.itemHeight !== element.clientHeight) {
            this.itemHeight = element.clientHeight;
        }
        this._focusedElement = new KeyboardFocusable(element);
        this._focusedElement.focus();
        this.isFocused = false;
    }

    focus(idx) {
        if (typeof idx === 'number') {
            this._currentIndex = idx;
            this.scrollContainerToEndOrBegin();
            this.selectElement();
        }
        this.isFocused = true;
    }

    unfocus() {
        if (this._focusedElement) {
            this._focusedElement.unfocus();
            this._focusedElement = null;
        }
    }

    enter() {
        this._focusedElement.enter();
    }

    isPossibleUp() {
        return this._currentIndex !== 0 && this._items.length !== 0;
    }

    isPossibleDown() {
        return this._currentIndex !== this._items.length - 1 && this._items.length !== 0;
    }

    scrollContainerToEndOrBegin() {
        if (this._currentIndex === 0) {
            this._container.scrollTo(0, -this._container.scrollHeight);
        } else {
            this._container.scrollTo(0, this._container.scrollHeight);
        }
    }

    up() {
        if (this.isPossibleUp()) {
            this.unfocus();
            this._currentIndex -= 1;
            this.selectElement();
        }
        if (this._focusedElement?.el.offsetTop <= this._container?.scrollTop) {
            this._container.scrollTo(0, this._container.scrollTop - this.itemHeight);
        }
    }

    down() {
        if (this.isPossibleDown()) {
            this.unfocus();
            this._currentIndex += 1;
            this.selectElement();
        }
        if (this._focusedElement?.el.offsetTop + this.itemHeight >= this._container?.clientHeight) {
            this._container.scrollTo(0, this._container.scrollTop + this.itemHeight);
        }

    }
}
